import React from 'react';
import PropTypes from 'prop-types';

import { SkeletonImage, SkeletonText } from 'components/Skeleton';

import isMappedTo from '../utility/isMappedTo';
import './RelationshipDisplayItemSkeleton.scss';

function RelationshipDisplayItemSkeleton ({ label }) {

	const showRoundedButton = isMappedTo.displayOptions.showRoundedButton(label);
	const showThumbnail = isMappedTo.displayOptions.showThumbnail(label);
	const showLabel = isMappedTo.displayOptions.showLabel(label);
	const showPrice = isMappedTo.displayOptions.showPrice(label);
	const displayArea = isMappedTo.displayOptions.displayArea.which(label);

	let height = 100;

	if (showRoundedButton) {

		if (showLabel && showPrice) {

			height = 55;

		} else {

			height = 35;

		}

	}

	return (
		<div className="RelationshipDisplayItemSkeleton">
			{showThumbnail && (
				<div className="RelationshipDisplayItemSkeleton__thumbnail">
					<SkeletonImage height={height} width={105} />
					{displayArea === 'outsideButton' && showLabel && <SkeletonText lines={2} width="105" />}
				</div>
			)}
			{showRoundedButton && <SkeletonImage height={height} width={97} />}
		</div>
	);

}
RelationshipDisplayItemSkeleton.propTypes = {
	label: PropTypes.string
};
export default RelationshipDisplayItemSkeleton;
